import Vue from 'vue'
import store from '@/store.js'
import App from './App'
import router from './router'
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueHead from 'vue-head'
import vueSmoothScroll from 'vue-smooth-scroll'

Vue.use(BootstrapVue)
Vue.use(VueHead, { separator: ' | ' })
Vue.use(vueSmoothScroll);

// 認証関連
import firebase from 'firebase'
// Firebaseで新たにプロジェクトを作ったら以下を差し替え
// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAMRxOEx6smaxNHBTh0NVQJeWnwVFndiTE",
  authDomain: "portfolio-6d299.firebaseapp.com",
  databaseURL: "https://portfolio-6d299.firebaseio.com",
  projectId: "portfolio-6d299",
  storageBucket: "portfolio-6d299.appspot.com",
  messagingSenderId: "643029270797",
  appId: "1:643029270797:web:80d231bfdf9a6c0ed6f044",
  measurementId: "G-S88N8H2ZFP"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
// ここまで差し替え

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js